import * as React from 'react';
import FixedMenuLayout from '../layouts/FixedMenuLayout';

const App = () => {
    return <FixedMenuLayout />;
}

export default App;